import { createSlice } from "@reduxjs/toolkit";
import { getAdminRefundListThunk, getAdminRefundDetailsThunk } from "../thunks/refundThunk";

const initialState = {
    refunds: [],
    total: 0,
    page: 1,
    limit: 20,
    selected: null,
};

const refundSlice = createSlice({
    name: "refund",
    initialState,
    reducers: {
        clearSelectedRefund: (state) => {
            state.selected = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAdminRefundListThunk.fulfilled, (state, action) => {
                state.refunds = action.payload?.data || [];
                state.total = action.payload?.total || 0;
                state.page = action.payload?.page || 1;
                state.limit = action.payload?.limit || 20;
            })
            .addCase(getAdminRefundDetailsThunk.fulfilled, (state, action) => {
                state.selected = action.payload?.data || null;
            });
    },
});

export const { clearSelectedRefund } = refundSlice.actions;
export default refundSlice.reducer;
